import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/loginNew',
    name: 'loginNew',
    component: () => import('@/views/tutor/login.vue')
  },
  {
    path: '/registerNew',
    name: 'registerNew',
    component: () => import('@/views/tutor/register.vue')
  },
  {
    path: '/studentHomepage',
    name: 'studentHomepage',
    component: () => import('@/views/student/studentHomepage.vue'),
    meta: { requiresAuth: true, requiresActiveLicense: true }
  },
  {
    path: '/studentLearn',
    name: 'studentLearn',
    component: () => import('@/views/student/learn/index.vue'),
    meta: { requiresAuth: true, requiresActiveLicense: true }
  },
  {
    path: '/studentQuiz',
    name: 'studentQuiz',
    component: () => import('@/views/student/quiz/index.vue'),
    meta: { requiresAuth: true, requiresActiveLicense: true }
  },
  {
    path: '/quizResults',
    name: 'quizResults',
    component: () => import('@/views/student/quiz/results.vue'),
    meta: { requiresAuth: true, requiresActiveLicense: true }
  },
  {
    path: '/quizHistorical',
    name: 'quizHistorical',
    component: () => import('@/views/student/quiz/historical.vue'),
    meta: { requiresAuth: true, requiresActiveLicense: true }
  },
  {
    path: '/pointLearn',
    name: 'pointLearn',
    component: () => import('@/views/student/learn/pointLearn.vue'),
    meta: { requiresAuth: true, requiresActiveLicense: true }
  },
  {
    path: '/parentOrTeacher',
    name: 'parentOrTeacher',
    component: () => import('@/views/parentOrTeacher/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/',
    redirect: '/landing'
  },
  {
    path: '/landing',
    name: 'Landing',
    component: () => import('@/views/Landing.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/billing',
    name: 'billing',
    component: () => import('@/views/billing.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () => import('@/views/verify/index.vue')
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () => import('@/views/verify/email.vue')
  },
  {
    path: '/creditCard',
    name: 'creditCard',
    component: () => import('@/views/creditCard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/verify/activated',
    name: 'VerifyActivated',
    component: () => import('@/views/verify/Activated.vue')
  },
  {
    path: '/teachers',
    name: 'Teachers',
    component: () => import('@/views/Teachers.vue')
  },
  {
    path: '/teacherManagement',
    name: 'teacherManagement',
    component: () => import('@/views/teacherManagement/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/SelectUser',
    name: 'SelectUser',
    component: () => import('@/views/SelectUser.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/Chat.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  // Nginx 已配置 try_files $uri $uri/ /index.html; 可支持 history 模式直达路由
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 导航守卫
router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  const token = localStorage.getItem('token')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!userInfo || !token) {
      next({
        path: '/loginNew',
        query: { redirect: to.fullPath }
      })
    } else if (to.matched.some(record => record.meta.requiresActiveLicense) && isExpiredStudent(userInfo)) {
      next({
        path: '/billing',
        query: { renewal: 'required', redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

function isExpiredStudent (userInfo) {
  if (!userInfo || userInfo.role !== 'S' || !userInfo.expireTime) return false
  const expireAt = new Date(userInfo.expireTime).getTime()
  return Number.isFinite(expireAt) && expireAt <= Date.now()
}

export default router
